import React, { useEffect, useState } from "react";
import CampaignInfo from "./CreateCampaignSection/CampaignInfo";
import CampaignSelectAudience from "./CreateCampaignSection/CampaignSelectAudience";
import CampaignSelectEmail from "./CreateCampaignSection/CampaignEmailSection";
import CampaignSubject from "./CreateCampaignSection/CampaignSubject";
import CampaignContent from "./CreateCampaignSection/CampaignContent";
import CampaignSchedule from "./CreateCampaignSection/CampaignSchedule";
import CampaignTest from "./CreateCampaignSection/CampaignTest";
import CampaignBottomSection from "./CreateCampaignSection/CampaignBottomSection";
import CampaignScheduleModal from "./CreateCampaignSection/CampaignScheduleModal";
import CampaignABTestScheduleModal from "./CreateCampaignSection/CampaignABTestScheduleModal";
import { useSelector, useDispatch } from "react-redux";
import { getPermissions } from 'api/UsersApi'
import SupportLink from "../Common/SupportLink";
import moment from "moment";

import {
  setCampaignName,
  setCampaignDescription,
  setCampaignType,
  setCampaignSubject,
  setCampaignAudienceName,
  setCampaignAudienceId,
  setCampignTemplateId,
  setCampaignFlow,
  setComplaiceStatus,
  setCampaignStatus,
  setCampaignEmail,
  setCampaignIsAdvisor,
  setCampaignWidget,
  //ABTest
  setCampaignABTestChecked,
  setCampaignABTestEnabled,
  setCampaignHtml,
  setCampaignABTestVariation,
  setCampaignABTestPercentage,
  setCampaignABTestWaitTime,
  setCampaignABTestId,
  setCampaignABTestSubject,
  setCampaignABTestTemplateId,
  setCampaignABTestDecidingParameter,
  setwordpressFlag,
  setCategory
} from "ReduxStore/Slices/campaignSlice";
import { setUserFlow } from "ReduxStore/Slices/userSlice";
import { getCampaignInfo } from "api/CampaignApi";
import ContantLoader from "views/ContantLoader";
import { useHistory } from 'react-router-dom'
import { setCC } from "ReduxStore/Slices/campaignSlice";
import { setBCC } from "ReduxStore/Slices/campaignSlice";

function CreateCampaign(props) {
  const campaignData = useSelector((state) => state.campaignSetter);
  const userData = useSelector((state) => state.userSetter);
  const [loadingState, setLoadingState] = useState(false);
  const [campaignHtmlData, setCampaignHtmlData] = useState(null);
  const [campaignAbTestHtmlData, setCampaignAbTestHtmlData] = useState(null);

  const [campaignSchedulePermission, setCampaignSchedulePermission] = useState(true);
  const [publishedButtonPermission, setPublishedButtonPermission] = useState(true);
  const [permissionMessage, setPermissionMessage] = useState(null);
  const [showPermissionMessage, setShowPermissionMessage] = useState(true);
  const [campaignSchedule, setCampaignSchedule] = useState(null)
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if ((campaignData.campaignId && campaignData.campaignEditMode) || campaignData.campaignViewMode) {

      setLoadingState(true);
      getCampaignInfo(campaignData.campaignId)
        .then((data) => {
          console.log("vvsetwordpressFlag",data)
          dispatch(setwordpressFlag(data.wordpressFlag))
          dispatch(setCampaignName(campaignData.campaignName == '' ? data.name : campaignData.campaignName));
          dispatch(setCampaignDescription(campaignData.campaignDescription == '' ? data.description : campaignData.campaignDescription));
          dispatch(setCampaignType(campaignData.campaignType == '' ? data.type : campaignData.campaignType));
          dispatch(setCampaignSubject(campaignData.campaignSubject == '' ? data.subject : campaignData.campaignSubject));
          dispatch(setCampaignAudienceName(campaignData.campaignAudienceName == '' ? "" : campaignData.campaignAudienceName));
          dispatch(setCampaignAudienceId(campaignData.campaignAudienceId == '' ? data.audienceId : campaignData.campaignAudienceId));
          dispatch(setCampaignEmail(campaignData.campaignEmail == '' ? data.fromEmail : campaignData.campaignEmail));
          dispatch(setCC(campaignData.cc == '' ? data.cc : campaignData.cc));
          dispatch(setBCC(campaignData.bcc == '' ? data.bcc : campaignData.bcc))
          dispatch(setCampignTemplateId(campaignData.campignTemplateId == null ? data.templateId : campaignData.campignTemplateId));
          dispatch(setCampaignStatus(campaignData.campaignStatus == '' ? data.status : campaignData.campaignStatus));
          dispatch(setCampaignFlow(true));
          dispatch(setUserFlow("createCampaign"));
          dispatch(setComplaiceStatus(data.complianceStatus));
          dispatch(setCampaignABTestChecked(campaignData.campaignABTestChecked == false ? data.isABTest : campaignData.campaignABTestChecked));
          dispatch(setCampaignABTestEnabled(campaignData.campaignABTestEnabled == false ? data.isABTest : campaignData.campaignABTestEnabled));
          dispatch(setCampaignABTestVariation(campaignData.campaingABTestData.campaignABTestVariation == '' ? data.ABTestData.variationType : campaignData.campaingABTestData.campaignABTestVariation));
          dispatch(setCampaignABTestPercentage(campaignData.campaingABTestData.campaignABTestPercentage == 10 ? data.ABTestData.samplePercentage : campaignData.campaingABTestData.campaignABTestPercentage));
          dispatch(setCampaignABTestWaitTime(campaignData.campaingABTestData.campaignABTestWaitTime == 0.5 ? data.ABTestData.waitTime : campaignData.campaingABTestData.campaignABTestWaitTime));
          dispatch(setCampaignABTestId(campaignData.campaingABTestData.campaignABTestId == '' ? data.ABTestData.ABTestCampaignId : campaignData.campaingABTestData.campaignABTestId));
          dispatch(setCampaignABTestSubject(campaignData.campaingABTestData.campaignABTestSubject == '' ? data.ABTestData.subject : campaignData.campaingABTestData.campaignABTestSubject));
          dispatch(setCampaignABTestTemplateId(campaignData.campaingABTestData.campaignABTestTemplateId == '' ? data.ABTestData.templateId : campaignData.campaingABTestData.campaignABTestTemplateId));
          dispatch(setCampaignABTestDecidingParameter(campaignData.campaingABTestData.campaignABTestDecidingParameter == '' ? data.ABTestData.decidingParameter : campaignData.campaingABTestData.campaignABTestDecidingParameter));
          setCampaignSchedule(data.campaignSchedule)
          dispatch(setCampaignHtml(data["grapesjs-react-editorhtml"]))
          dispatch(setCampaignIsAdvisor(data.isAdvisorConnect))
          dispatch(setCampaignWidget(data.widgetType))
          dispatch(setCategory(data.category))
      
          console.log(campaignData)
          // condition for template view
          if (data.ABTestType == 'A') {
            setCampaignHtmlData(data.type === "email" ? data["convertedHtml"] : data["grapesjs-react-editorhtml"])
            setCampaignAbTestHtmlData(data.type === "email" ? data.ABTestData["convertedHtml"] : data.ABTestData["grapesjs-react-editorhtml"])
          } else if (data.ABTestType == 'B') {
            setCampaignHtmlData(data.type === "email" ? data.ABTestData["convertedHtml"] : data.ABTestData["grapesjs-react-editorhtml"])
            setCampaignAbTestHtmlData(data.type === "email" ? data["convertedHtml"] : data["grapesjs-react-editorhtml"])
          } else {
            setCampaignHtmlData(data.type === "email" ? data["convertedHtml"] : data["grapesjs-react-editorhtml"])
          }
          setLoadingState(false);
        })
        .catch((e) => { });
    }

  }, []);

  useEffect(() => {
    getPermissions().then(res => {
      if (campaignData.campaignType === "email") {
        setCampaignSchedulePermission(res["ScheduleEmailCampaigns"].allowed)
        setPermissionMessage(res["ScheduleEmailCampaigns"].message)
      } else if (campaignData.campaignType === "publishedContent") {
        setPublishedButtonPermission(res["PublishWebpageCampaigns"].allowed)
        setPermissionMessage(res["PublishWebpageCampaigns"].message)
      }
    })
  }, [campaignData.campaignType])
  const campaignTypeHandler = () => {
    if (campaignData.campaignType === "email") {
      return (
        <>
          <CampaignSelectAudience />
          <CampaignSelectEmail />
          <CampaignSubject />
          <CampaignContent htmlData={campaignHtmlData} abTestHtmlData={campaignAbTestHtmlData} />
          {campaignSchedule && campaignSchedule.firstRunDate  &&<div style={{ fontSize: '16px',
              margin: '27px 0px 0px 0px',
              fontWeight: '900' }}
              >
            Scheduled to run on :
            {campaignSchedule.type === "now" || campaignSchedule.type === "once" ?
              `${moment(campaignSchedule.firstRunDate).format('MM/DD/YYYY')} : ${campaignSchedule.runTime} EST` : `${campaignSchedule.type}, ${campaignSchedule.typeValue}, ${moment(campaignSchedule.firstRunDate).format('MM/DD/YYYY') } : ${campaignSchedule.runTime} EST`}
            
            
            </div>
          }
          {!(
            ((userData.role === "compliance" || userData.role === "designer") &&
              userData.companyLevelComplaiceFlag === true) || campaignData.campaignViewMode
          ) && (
              <>
                <CampaignSchedule campaignSchedulePermission={campaignSchedulePermission} />
              </>
            )}
          {
            (!campaignData.campaignViewMode) && <CampaignTest />
          }

          <CampaignBottomSection />
          <CampaignScheduleModal />
          <CampaignABTestScheduleModal />
        </>
      );
    } else if (campaignData.campaignType === "publishedContent") {
      return (
        <>
          <CampaignContent htmlData={campaignHtmlData} abTestHtmlData={campaignAbTestHtmlData} />
          {/* <div style={{
            fontSize: '16px',
            margin: '27px 0px 0px 0px',
            fontWeight: '900'
          }}
          >
            Scheduled to run on: Date and Time
          </div> */}
          <CampaignBottomSection publishedButtonPermission={publishedButtonPermission} />
          
        </>
      );
    } else if (campaignData.campaignType === "") {
      return <></>;
    }
  };

  const messageBar = (permissionMessage) => {
    if (permissionMessage) {
      return (
        showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
          <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>

          <span onClick={() => {
            setShowPermissionMessage(false)
          }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
        </div>
      )
    }
  }

  return (
    <>
      {messageBar(permissionMessage)}
      {loadingState ? (
        <ContantLoader />
      ) : (
        <>
          <SupportLink link='https://kapitalwise.com/user-guide/campaign/' />

          <div className="page_heading">
            <h2> Create Campaign </h2>
            {
              (campaignData.campaignViewMode || campaignData.campaignEditMode) && <button
                className="btn btn-sm"
                style={{ color: "#114169" }}
                onClick={() => history.push(`/admin/campaign/all`)}
              >{`< Back`}</button>
            }

          </div>
          <div className="campaign_outer">
            <CampaignInfo />
            {campaignTypeHandler()}
          </div>
        </>
      )}
    </>
  );
}

export default CreateCampaign;
